import { Charts } from './Charts';
import OcurrencesChartsDataProvider from './contexts/OcurrencesChartsDataContext';

const OcurrencesWrapper = () => {
    return (
        <OcurrencesChartsDataProvider>
            <Charts />
        </OcurrencesChartsDataProvider>
    );
};

export default OcurrencesWrapper;
